import { useState, useRef, useEffect } from 'react';

const reviews = [
  {
    quote: "The Butter Chicken here is absolutely divine! It genuinely reminds me of home-cooked meals back in Delhi. The warmth and authenticity is something I have not found anywhere else in South Carolina.",
    name: 'Priya Sharma',
    location: 'Greenville, SC',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Indian%20woman%20smiling%20portrait%20professional%20headshot%20warm%20background%20natural%20lighting&width=60&height=60&seq=1601&orientation=squarish',
  },
  {
    quote: "Best Indian food I have had outside of India. The tandoori platter is an absolute must-try — smoky, perfectly spiced, and beautifully presented. Chaska is the real deal.",
    name: 'Michael Reynolds',
    location: 'Duncan, SC',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=man%20smiling%20portrait%20professional%20headshot%20warm%20natural%20light%20background&width=60&height=60&seq=1602&orientation=squarish',
  },
  {
    quote: "Chaska brings authentic flavors with a modern twist. The restaurant itself is a work of art — the murals, the colors, the energy. I brought my whole family and everyone loved every single dish.",
    name: 'Sarah Liu',
    location: 'Spartanburg, SC',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=asian%20woman%20smiling%20portrait%20casual%20professional%20headshot%20warm%20lighting&width=60&height=60&seq=1603&orientation=squarish',
  },
  {
    quote: "The Lamb Biryani is out of this world. You can taste the care and tradition in every bite. The service is warm and the ambiance is vibrant — this is now my go-to Indian restaurant.",
    name: 'James Patel',
    location: 'Spartanburg, SC',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=man%20with%20glasses%20smiling%20portrait%20professional%20headshot%20warm%20background&width=60&height=60&seq=1604&orientation=squarish',
  },
];

export default function ReviewsSection() {
  const [current, setCurrent] = useState(0);
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const prev = () => setCurrent((c) => (c - 1 + reviews.length) % reviews.length);
  const next = () => setCurrent((c) => (c + 1) % reviews.length);

  const review = reviews[current];

  return (
    <section ref={ref} className="py-20 lg:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="font-sans text-xs uppercase tracking-[0.3em] text-saffron mb-3">Testimonials</p>
          <h2 className="font-serif text-4xl sm:text-5xl text-charcoal">What Our Guests Say</h2>
        </div>

        {/* Review Card */}
        <div
          className={`relative bg-white rounded-3xl p-8 sm:p-12 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ boxShadow: '0 4px 32px rgba(0,0,0,0.08)' }}
        >
          {/* Rating */}
          <div className="flex items-center gap-1 mb-6">
            {[...Array(review.rating)].map((_, i) => (
              <i key={i} className="ri-star-fill text-saffron text-lg"></i>
            ))}
            <span className="font-sans text-sm font-bold text-charcoal ml-2">5.0</span>
          </div>

          {/* Quote */}
          <div className="relative">
            <span className="font-serif text-6xl text-coral/30 absolute -top-4 -left-2 leading-none">&ldquo;</span>
            <p className="font-serif text-xl sm:text-2xl text-charcoal/85 leading-relaxed pl-6 pr-6">
              {review.quote}
            </p>
            <span className="font-serif text-6xl text-coral/30 absolute -bottom-8 right-0 leading-none">&rdquo;</span>
          </div>

          {/* User */}
          <div className="flex items-center justify-between mt-10">
            <div className="flex items-center gap-4">
              <img
                src={review.avatar}
                alt={review.name}
                className="w-14 h-14 rounded-full object-cover"
              />
              <div>
                <p className="font-sans font-bold text-charcoal text-base">{review.name}</p>
                <p className="font-sans text-sm text-charcoal/50">{review.location}</p>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex items-center gap-3">
              <button
                onClick={prev}
                className="w-11 h-11 flex items-center justify-center rounded-xl border-2 border-charcoal/15 text-charcoal hover:border-teal hover:text-teal transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={next}
                className="w-11 h-11 flex items-center justify-center rounded-xl bg-teal text-white hover:bg-saffron transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-8">
            {reviews.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`rounded-full transition-all duration-200 cursor-pointer ${
                  i === current ? 'w-6 h-2 bg-saffron' : 'w-2 h-2 bg-charcoal/20'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Google rating note */}
        <div className="text-center mt-8">
          <p className="font-sans text-sm text-charcoal/50">
            <i className="ri-google-fill text-[#EA4335] mr-1"></i>
            Rated 4.9/5 on Google Reviews
          </p>
        </div>
      </div>
    </section>
  );
}
